import React from 'react';
import { handleNavigationWithArrowKeys, trackRecentSearch } from '../utils';
import './style.scss';

const TrendingProductsList = () => {
  const { searchDeadEndSuggestedTerms = {} } = window.AloSearchSettings;
  const suggestedSearchTerms = Object.keys(searchDeadEndSuggestedTerms);

  return suggestedSearchTerms && suggestedSearchTerms.length > 0 ? (
    <div className="trending-search-block" id="trending-search-block d-flex flex-column" role="list">
      <h6 className="header-title h6">Trending Searches</h6>
      <ul className="search-items-list d-flex ml-0">
        {suggestedSearchTerms.map((label, index) => {
          const url = searchDeadEndSuggestedTerms[label] || '';
          return (
            <li
              key={index}
              tabIndex={-1}
              className="search-product main-navbar__sub-sub-item search-link"
              onKeyDown={(e) => {
                handleNavigationWithArrowKeys(e, url);
              }}
            >
              <a
                data-link-type="sta_canned_suggestion"
                href={url}
                onClick={() => {
                  trackRecentSearch(label);
                }}
              >
                {label}
              </a>
            </li>
          );
        })}
      </ul>
    </div>
  ) : null;
};

export default TrendingProductsList;
